import React from 'react';

export default function Temperature({ temp_min, temp_max, bed_temp_min, bed_temp_max, fan_speed_min, fan_speed_max, notes }) {
  const hasFan = fan_speed_min !== null && fan_speed_min !== undefined
    || fan_speed_max !== null && fan_speed_max !== undefined;
  const showMaxOnly = fan_speed_min === 0;
  return (
    <div>
      <strong>Temperatura</strong>
      <div className="small mb-0">
        <div>Zakres temperatur dyszy (°C): {temp_min ?? '-'} — {temp_max ?? '-'}</div>
        <div>Zakres temperatur stołu (°C): {bed_temp_min ?? '-'} — {bed_temp_max ?? '-'}</div>
        {hasFan && (
          <div>
            Prędkość wentylatora:{' '}
            {showMaxOnly
              ? <>max {fan_speed_max ?? '-'}</>
              : <>{fan_speed_min ?? '-'} — {fan_speed_max ?? '-'}</>
            } (%)
          </div>
        )}
        {notes && (
          <div className="mt-1">{notes}</div>
        )}
      </div>
    </div>
  );
}
